export const EMPTY_USER_STATS = {
  reportGeneratedAt: "",
  startDate: "",
  endDate: "",
  quickStats: {
    totalUsers: 0,
    newUsersToday: 0,
    newUsersThisWeek: 0,
    newUsersThisMonth: 0,
    activeUsersToday: 0,
    activeUsersThisWeek: 0,
    dormantUsers: 0,
    pendingVerifications: 0,
    lockedAccounts: 0,
    failedLoginsToday: 0,
  },
  registrationSummary: {
    totalRegistrations: 0,
    completedRegistrations: 0,
    failedRegistrations: 0,
    abandonedRegistrations: 0,
    completionRate: 0,
    averageRegistrationTimeMs: null,
    mostCommonDropOffStage: null,
  },
  loginSummary: {
    totalLogins: 0,
    successfulLogins: 0,
    failedLogins: 0,
    successRate: 0,
    uniqueUsersLoggedIn: 0,
    mostCommonFailureReason: null,
    suspiciousActivities: null,
  },
  verificationSummary: {
    bvnVerificationsCompleted: 0,
    ninVerificationsCompleted: 0,
    kycDocumentsVerified: 0,
    pendingNinApprovals: 0,
    pendingKycApprovals: null,
    overallVerificationRate: null,
  },
  activityTrends: null,
  alerts: null,
  usersByState: null,
};
